import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import ReactPixel from 'react-facebook-pixel';
import { App } from './App';
ReactPixel.init('401851746104415', undefined, {
  autoConfig: true,
  debug: false
});
ReactPixel.pageView();
render(<App data-id="element-206" />, document.getElementById('root'));